import React from 'react'
import { Loading } from '../../../components/Loading';
import { TableCustom } from '../../../components/table/Table';
import { MyCouponType } from '../../../models/dto/entry';
import Dialog from '../../../components/dialog/Dialog';
import { formatDateTime, formatNumber, updateState } from '../../../utils/function-utils';
import { RedeemCode } from '../../../components/coupon/RedeemCode';
import { Logger } from '../../../utils/logger';
import { useInitialCofig } from '../../../hooks/initialConfig-hook';
//AVCDAAV.002  20/03/2025  Add code for Adding coupon history page

type ErrorPopup = {
    errorMycoupon: {
        status: boolean,
        message: string;
    };
};

type PopupShow = {
    showPopupSuccessHistory: boolean;
};

const initialShowPopup: PopupShow = {
    showPopupSuccessHistory: false
};

type Props = {
    myCoupon?: MyCouponType[];
}
const MyCoupon = (props: Props) => {
    const nameOfPage = "MyCoupon.tsx";
    const { initialConfig } = useInitialCofig();
    const [loading, setLoading] = React.useState<boolean>(false);
    const [showPopup, setShowPopup] = React.useState<PopupShow>(initialShowPopup);
    const [error, setError] = React.useState<ErrorPopup>({
        errorMycoupon: {status: false, message: "" }
    });
    const [active, setActive] = React.useState<{myCoupon?: MyCouponType; index?: number}>({
        myCoupon: undefined,
        index: undefined,
    });
    const [headerTable] = React.useState<string[]>(["Date", "Coupon", "Point"]);

    async function handleClickHistory(couponCode: string, index: number) {
        try {
            setLoading(true);
            const couponExist = props.myCoupon?.find((c) => c.couponCode === couponCode);
            if (!couponExist) {
                throw new Error("เกิดข้อผิดพบลาด");
            }
            setActive({myCoupon: couponExist, index: index});
            setTimeout(() => {
                setLoading(false);
                setShowPopup({ showPopupSuccessHistory: true });
            }, 1500);

        } catch (error: any) {
            setTimeout(() => {
                setLoading(false);
                Logger.logError(nameOfPage, `${error.message}`);
                updateState<ErrorPopup>({errorMycoupon: {status:true, message: error.mesage}}, setError);
            },1500);
        }
    }

    const renderTableRows = () => {
        return props.myCoupon?.sort((a, b) => {
            const latestDate = new Date(`${b.createDate} ${b.createTime}`).getTime();
            const prevDate = new Date(`${a.createDate} ${a.createTime}`).getTime();
            return latestDate - prevDate
        }).map((item, i) => {
            const isActive = i === active.index;
            return (
                <tr key={item.couponCode} onClick={() => handleClickHistory(item.couponCode, i)}
                    style={{ 
                        ...initialConfig.styles.title2_style,
                        backgroundColor: isActive ? initialConfig.styles.icon_style.color : undefined, 
                        color: isActive ? "white" : undefined,
                    }}
                >
                    <td>{formatDateTime(item.createDate)}</td>
                    <td style={{ textAlign: 'left', overflow: "hidden", whiteSpace: "nowrap", maxWidth: "200px", textOverflow: "ellipsis" }}>{item.couponDesc}</td>
                    <td style={{ textAlign: "right" }}>{item.pointforRedeem === 0 ? "ฟรี" : formatNumber("en-US", item.pointforRedeem)}</td>
                </tr>
            )
        });
    };

    if(!props.myCoupon || props.myCoupon.length === 0) return (
        <div className='box-loading'>
            <div className={`loading-container ${'with-bottombar'} smallest`}>
                ไม่มีคูปอง
            </div>
        </div>
    )

    return (
        <React.Fragment>
            <div className='history'>
              <TableCustom  renderTableRows={renderTableRows}styleConfig={initialConfig.styles} theadCentered 
                  tbodyCentered tbodyStyle={{fontSize: "14px", fontWeight: "bold", backgroundColor: "white"}} headers={headerTable}
              />
            </div>
            <Dialog show={loading} handleClose={() => setLoading(false)} backdropClassName='font-loading-backdrop' dialogStyles={{ zIndex: 1201 }} loading>
                <Loading size='smallest' centered witoutBottombar />
            </Dialog>

            <Dialog.Error show={error.errorMycoupon.status} handleClose={() => 
                updateState<ErrorPopup>({errorMycoupon: {status: false, message: ""}}, setError)}
                dialogBodyStyles={initialConfig.styles.error_message_box_style}
            >
                {error.errorMycoupon.message}
            </Dialog.Error>

            <RedeemCode type='sidebar' show={showPopup.showPopupSuccessHistory} onHide={() => {
                updateState<PopupShow>({ showPopupSuccessHistory: false }, setShowPopup);
                setActive({myCoupon: undefined, index: undefined});
            }}
                code={active.myCoupon?.couponBarcode}
                couponDesc={active.myCoupon?.couponDesc}
            />
        </React.Fragment>
    )
}

export default MyCoupon
//C-AVCDAAV.002  20/03/2025  Add code for Adding coupon history page